// Utility functions for FullStory tracking
export const trackModalView = (capability, modalType) => {
    console.log('Modal action:', {
        type: 'modal_interaction',
        action: modalType,
        capability,
        'data-fs': `${capability}-modal-${modalType}`,
        'aria-label': `${capability} Analytics Modal`
    });
};

export const getModalAttributes = (capability) => ({
    'data-fs': `${capability}-modal`,
    'aria-label': `${capability} Analytics Modal`,
    className: `${capability.toLowerCase()}-modal`
});

/* istanbul ignore next */
export const getAppLinkAttributes = (appName) => {
    appName = appName.replace(" (F)", "");
    return {
        'data-fs': `${appName}-external-app-link`,
        'aria-label': `${appName}-external-app-link`
    }
        
};
